/**
 * FILE: src/blueprint/components/report/TitleBlock.jsx
 */

function asString(value) {
  return typeof value === 'string' ? value : '';
}

export default function TitleBlock({ value, level = 2 }) {
  const text = asString(value).trim();
  if (!text) return null;

  const numericLevel = Number(level);
  const safeLevel = Number.isFinite(numericLevel)
    ? Math.min(6, Math.max(1, Math.trunc(numericLevel)))
    : 2;

  const Tag = `h${safeLevel}`;

  return <Tag>{text}</Tag>;
}
